export default __webpack_public_path__ + "media/images/map/car/64x64-530355a52618aaa521ef584ba5852392.png";